import { useTenantStore } from '../state/tenant.store';

/**
 * TenantFooterPlaceholder - minimal tenant indicator.
 *
 * PROD-568 will replace this with the real tenant switcher + tenant-scoped
 * org branding strip.
 */
export function TenantFooterPlaceholder() {
  const tenantId = useTenantStore((s) => s.tenantId);

  return (
    <footer className="border-t border-surface-border px-gutter-lg py-gutter-md text-signal-xs text-text-tertiary flex justify-between">
      <span>Tenant: {tenantId}</span>
      <span>Pathway Studio Prototype - Phase 1</span>
    </footer>
  );
}
